import React from 'react';
import { useDispatch } from 'react-redux';
import { updateShowViewWaitingAreaOperatingHoursModal } from '../../../../actions/modal';

export default function RightPanelView(props) {
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(updateShowViewWaitingAreaOperatingHoursModal(false));
  };
  return (
    <div>
      <div className="ui actions mrbl max-width mrtxxs ">
        <button
          onClick={closeModal}
          className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Close}
        </button>
      </div>
    </div>
  );
}
